import React, { Component } from "react";
import IdeasList from "./components/IdeasList";
import LoginRegister from "./components/LoginRegister";
import ForgotPassword from "./components/ForgotPassword";
import Admin from "./components/Admin";
import AdminUsers from "./components/AdminUsers";
import ResetPassword from "./components/ResetPassword";
import { BrowserRouter as Switch, Route, Link } from "react-router-dom";
import auth from "./services/authService.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import ProtectedRoute from "./common/protectedRoute";
import {
  faLightbulb,
  faCheck,
  faThumbsUp,
  faTrash,
  faTrashAlt
} from "@fortawesome/free-solid-svg-icons";
import "./App.css";
import AdminMenu from "./components/AdminMenu";
library.add(faLightbulb, faCheck, faThumbsUp, faTrash, faTrashAlt);

class App extends Component {
  state = {};
  renderHomePage(props) {
    const user = auth.getCurrentUser();
    if (user) {
      return <IdeasList {...props}></IdeasList>;
    } else {
      return (
        <LoginRegister
          {...props}
          onLogin={() => {
            this.readUser();
          }}
        ></LoginRegister>
      );
    }
  }
  renderUserName() {
    if (this.state.user) {
      return (
        <div>
          Hello, {this.state.user.fullName} |{" "}
          <a
            className=""
            href="# "
            onClick={() => {
              auth.logout();
              this.readUser();
            }}
          >
            Logout
          </a>
        </div>
      );
    }
  }
  componentDidMount() {
    this.readUser();
  }
  readUser() {
    const user = auth.getCurrentUser();
    this.setState({ user });
  }

  render() {
    return (
      <React.Fragment>
        <Switch>
          <main role="main">
            <div className="layout layout-nav-top layout-sidebar">
              <div className="navbar navbar-expand-lg bg-dark navbar-dark sticky-top">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link className="nav-link" to="/">
                      Customer Feedback Portal
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="main-container">
                <div className="content-container">
                  <div className="breadcrumb-bar navbar bg-white sticky-top">
                    <nav aria-label="breadcrumb">
                      Lanteria HR
                      <AdminMenu></AdminMenu>
                    </nav>
                    <div className="text-small">{this.renderUserName()}</div>
                  </div>
                  <div className="pt-1">
                    <ProtectedRoute
                      path="/admin"
                      render={props => <Admin {...props} />}
                    ></ProtectedRoute>
                    <ProtectedRoute
                      path="/adminUsers"
                      render={props => <AdminUsers {...props} />}
                    ></ProtectedRoute>
                    <Route
                      path="/login"
                      render={props => (
                        <LoginRegister
                          {...props}
                          onLogin={() => {
                            this.readUser();
                          }}
                        />
                      )}
                    ></Route>
                    <Route
                      path="/forgot-password"
                      render={props => <ForgotPassword {...props} />}
                    ></Route>
                    <Route
                      path="/reset-password"
                      render={props => (
                        <ResetPassword
                          {...props}
                          onLogin={() => {
                            this.readUser();
                          }}
                        />
                      )}
                    ></Route>
                    <ProtectedRoute
                      exact
                      path="/"
                      render={props => this.renderHomePage(props)}
                    ></ProtectedRoute>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </Switch>
      </React.Fragment>
    );
  }
}

export default App;
